import React from 'react';

import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { Modal, Button, DateSelector, Dropdown } from 'components';
import { ModalProps } from 'components/Modal';

export interface NewTimeModalProps extends ModalProps {
  saveTime: (time: string, saveTime: string) => void;
  date: Date;
  reservedDates: string[];
}

const NewTimeModal: React.FC<NewTimeModalProps> = (props) => {
  const { visible, saveTime, date: selectedDate, reservedDates, onClose, fixHeight } = props;
  const { t } = useTranslation();

  const [time, setTime] = React.useState<Date>(selectedDate);
  const [length, setLength] = React.useState<string>('15');

  React.useLayoutEffect(() => {
    const defaultDate = new Date(selectedDate);
    defaultDate.setMinutes(0);
    defaultDate.setSeconds(0);
    setTime(defaultDate);
  }, [selectedDate]);

  const hasNoConflictWithReservedDates = (newAppointmentDate: string) => {
    const newMoment = moment(newAppointmentDate);

    for (const start of reservedDates) {
      const startMoment = moment(start);
      const endMoment = moment(start).add(length, 'minute');
      const newMomentEnd = moment(newMoment).add(length, 'minute');

      const hasConflict = [newMoment, newMomentEnd].some((m) => m.isBetween(startMoment, endMoment, null, '[)'));

      if (hasConflict) {
        return false;
      }
    }

    return true;
  };

  const years = selectedDate.getFullYear();
  const months = selectedDate.getMonth();
  const days = selectedDate.getDate();
  const lengthOptions = ['15', '45'];

  const addDate: React.MouseEventHandler = () => {
    const hours = time.getHours();
    const minutes = time.getMinutes();
    const newAppointmentDate = moment({
      years,
      months,
      days,
      hours,
      minutes,
      seconds: 0,
    }).toISOString();

    if (hasNoConflictWithReservedDates(newAppointmentDate)) {
      saveTime(newAppointmentDate, length);
    }
  };

  return (
    <Modal className="max-w-[350px] md:max-w-full" title={t('calendar.newDateTitle')} visible={visible} onClose={onClose} fixHeight={fixHeight}>
      <div className="py-8">
        <DateSelector date={time} onChange={(newDate) => setTime(newDate)} />
      </div>
      <div className="flex justify-center text-teacher-blue font-semibold gap-8 md:gap-10">
        <div className="flex justify-content gap-6">
          <div className="mt-2">{t('calendar.changeLength')}</div>
          <Dropdown onChange={setLength} options={lengthOptions} defaultSelected={length} />
        </div>
      </div>
      <div className="flex justify-end mt-5">
        <Button onClick={addDate} variant="tertiary" labelClassName="font-semibold">
          {t('calendar.addDate')}
        </Button>
      </div>
    </Modal>
  );
};

export default NewTimeModal;
